var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 30,
    viewBox: "0 0 24 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crossbar",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.125,
    y1: 0,
    x2: 0.125,
    y2: 10,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 0.875,
    x2: 1,
    y2: 9.125,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 9.875,
    x2: 24,
    y2: 9.875,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 9,
    x2: 23.125,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.875,
    y1: 10,
    x2: 23.875,
    y2: 0,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 9,
    x2: 23,
    y2: 0.875,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.875,
    y1: 0.125,
    x2: 0.125,
    y2: 0.125,
    strokeWidth: 0.25,
    stroke: "black",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 1,
    x2: 1,
    y2: 1,
    strokeWidth: 0.25,
    stroke: "black",
    opacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "net",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "horizontal-net"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 2,
    x2: 23,
    y2: 2,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 3,
    x2: 23,
    y2: 3,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 4,
    x2: 23,
    y2: 4,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 5,
    x2: 23,
    y2: 5,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 6,
    x2: 23,
    y2: 6,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 7,
    x2: 23,
    y2: 7,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 8,
    x2: 23,
    y2: 8,
    strokeWidth: 0.25,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vertical-net"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 1,
    x2: 2,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 1,
    x2: 3,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 1,
    x2: 4,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 1,
    x2: 5,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 1,
    x2: 6,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 1,
    x2: 7,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 1,
    x2: 8,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 1,
    x2: 9,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 1,
    x2: 10,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 1,
    x2: 11,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 1,
    x2: 12,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 1,
    x2: 13,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 1,
    x2: 14,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 1,
    x2: 15,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 1,
    x2: 16,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 1,
    x2: 17,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 1,
    x2: 18,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 1,
    x2: 19,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 1,
    x2: 20,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 1,
    x2: 21,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 1,
    x2: 22,
    y2: 9,
    strokeWidth: 0.25,
    stroke: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.6558912fd4354bfb32b592a73140a734.svg";
export { ForwardRef as ReactComponent };